import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { pulizieApi } from './api';

const chiave = (username) => `pulizie_operatore:${username}`;

export const useOperatore = (utente) => {
  const [nome, setNome] = useState(null);
  useEffect(() => {
    if (utente) setNome(localStorage.getItem(chiave(utente.username)) || utente.nome);
  }, [utente]);
  const scegli = (n) => {
    if (n === utente.nome) localStorage.removeItem(chiave(utente.username));
    else localStorage.setItem(chiave(utente.username), n);
    setNome(n);
  };
  return [nome, scegli];
};

export const OperatoreDialog = ({ open, attuale, onClose, onScegli }) => {
  const [nomi, setNomi] = useState([]);
  const [altro, setAltro] = useState('');
  useEffect(() => {
    if (!open) return;
    setAltro('');
    pulizieApi.get('/operatori').then((d) => setNomi(d.nomi)).catch(() => setNomi([]));
  }, [open]);
  const usa = (n) => { onScegli(n.trim().replace(/\s+/g, ' ')); onClose(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="pulizie-operatore-dialog">
        <DialogHeader>
          <DialogTitle>Chi pulisce?</DialogTitle>
          <DialogDescription>Questo nome va nel registro a ogni Fatto. Il telefono se lo ricorda.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {nomi.map((n) => (
            <button key={n} onClick={() => usa(n)} data-testid={`pulizie-operatore-${n.toLowerCase().replace(/\s+/g, '-')}`}
              className={`px-3 py-2 rounded-full text-sm border transition-colors ${n === attuale ? 'bg-emerald-600 border-emerald-600 text-white' : 'border-gray-300 hover:bg-gray-100'}`}>
              {n}
            </button>
          ))}
        </div>
        <div className="flex gap-2">
          <Input value={altro} onChange={(e) => setAltro(e.target.value)} maxLength={60} placeholder="Altro nome e cognome"
            data-testid="pulizie-operatore-altro" />
          <Button onClick={() => usa(altro)} disabled={altro.trim().length < 2} data-testid="pulizie-operatore-usa">Usa</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
